import React from "react";
import { Container } from "reactstrap";
import { FaqCollapsible, FaqItem } from "./FaqCollapsible";

export interface FaqProps {
  items: FaqItem[];
}

export const Faq: React.FunctionComponent<FaqProps> = (props: FaqProps) => {
  return (
    <Container className="ps-faq">
      {props.items.map((f, i) => {
        return <FaqCollapsible key={i} item={f} />;
      })}
    </Container>
  );
};
